import { Skeleton } from "@/ui/library/skeleton";

const NotificationRowSkeleton = ({
  titleWidthClass = "w-56",
  timeWidthClass = "w-12",
}: {
  titleWidthClass?: string;
  timeWidthClass?: string;
}) => {
  return (
    <div className="-mx-1 flex w-full flex-col self-stretch px-6 py-1">
      <div className="inline-flex w-full items-center justify-between gap-3 self-stretch">
        <Skeleton className={"h-4 " + titleWidthClass} />
        <Skeleton className={"h-3 " + timeWidthClass} />
      </div>
      <div className="mt-1 inline-flex items-center justify-start gap-2">
        <Skeleton className="h-1.5 w-1.5 rounded-full" />
        <Skeleton className="h-3 w-24" />
      </div>
    </div>
  );
};

const SectionSkeleton = ({ rows = 4, headerWidthClass = "w-16" }: { rows?: number; headerWidthClass?: string }) => {
  const titleWidths = ["w-60", "w-48", "w-52", "w-44"];
  const timeWidths = ["w-10", "w-12", "w-8", "w-14"];

  return (
    <div className="w-full">
      <Skeleton className={"mx-4 mb-2 mt-6 h-3 " + headerWidthClass} />
      {Array.from({ length: rows }).map((_, idx) => (
        <NotificationRowSkeleton
          key={idx}
          titleWidthClass={titleWidths[idx % titleWidths.length]}
          timeWidthClass={timeWidths[idx % timeWidths.length]}
        />
      ))}
    </div>
  );
};

const NotificationListSkeleton = ({
  sections = 2,
  rowsPerSection = 4,
}: {
  sections?: number;
  rowsPerSection?: number;
}) => {
  return (
    <div role="status" aria-live="polite" aria-label="Notifications loading" aria-busy="true">
      {Array.from({ length: sections }).map((_, i) => (
        <SectionSkeleton key={i} rows={rowsPerSection} />
      ))}
    </div>
  );
};

export default NotificationListSkeleton;
